import { forwardRef } from 'react'
import { motion } from 'motion/react'
import Link from 'next/link'

const MotionLink = motion.create(Link)

export const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, any>(
  (
    {
      as = 'link',
      children,
      onClick = () => null,
      href = '',
      external = false,
      styled = true,
      className = '',
      tabIndex = 0,
      background = false,
      active = false,
      ...rest
    },
    forwardedRef
  ) => {
    const classes = `py-12 px-12 transition-colors duration-300 ease rounded-6 text-darkGray ${
      styled && !active ? 'md:hover:bg-white active:bg-white' : ''
    } ${background ? 'bg-lighterGray' : ''}`
    if (as === 'button' || !href) {
      return (
        <motion.button
          tabIndex={tabIndex}
          ref={forwardedRef as any}
          className={`${className} ${classes} chnge-button`}
          onClick={onClick}
          {...rest}
        >
          {children}
        </motion.button>
      )
    }
    return (
      <MotionLink
        scroll={false}
        tabIndex={0}
        ref={forwardedRef as any}
        href={href}
        onClick={onClick}
        target={external ? '_blank' : '_self'}
        rel={external ? 'noreferrer noopener' : ''}
        className={`${className} ${classes} chnge-button`}
        {...rest}
      >
        {children}
      </MotionLink>
    )
  }
)
